import { createFileRoute, Outlet } from '@tanstack/react-router';

import { ILinkAuth, useAuthorizationLinks } from '@/utils/linkAuth';
import PageContainer from '@/components/layout/PageContainer';
import SidebarNav from '@/components/layout/SidebarNav';
import { getGetCompanyQueryOptions } from '@area-restrita/api-client/endpoints/companies/companies.gen';

const sidebarNavItems: ILinkAuth[] = [
  {
    label: 'Visão Geral',
    to: '/company',
    authorization: ({ can }) => can('viewDetails', 'company'),
  },
  {
    label: 'Usuários',
    to: '/company/users',
    authorization: ({ can }) => can('list', 'company_memberships'),
  },
];

export const Route = createFileRoute(
  '/_authenticated/_system/_company/company',
)({
  loader: async ({ context: { queryClient } }) => {
    const company = await queryClient.ensureQueryData({
      ...getGetCompanyQueryOptions(),
      gcTime: 0,
      revalidateIfStale: true,
    });

    return company;
  },
  component: function CompanyPage() {
    const company = Route.useLoaderData();
    const items = useAuthorizationLinks(sidebarNavItems);

    return (
      <PageContainer title={`Empresa: ${company.tradingName}`} withSeparator>
        <div className="flex flex-1 flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0 w-full">
          <aside className="-mx-4 lg:w-1/5">
            <SidebarNav items={items} />
          </aside>
          <Outlet />
        </div>
      </PageContainer>
    );
  },
});
